import React, { useEffect,useState } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { Table, Tabs} from 'antd';
import { apiService } from '../services/apiService';
import { FaLongArrowAltLeft } from 'react-icons/fa';


const ActualSaleBulkUploadHistoryDetails = () => {  
    const { TabPane } = Tabs;
    const [successRecords, setSuccessRecords] = React.useState([]);
    const [failedRecords, setFailedRecords] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [total, setTotal] = useState(0); // Store total number of records for pagination
    const [totalSuccessRecords, setTotalSuccessRecords] = useState(0); // Store total number of success records for pagination
    const [totalFailedRecords, setTotalFailedRecords] = useState(0); // Store total number of failed records for pagination
  
    const [successPageSize, setSuccessPageSize] = useState(10);
      const [successCurrentPage, setSuccessCurrentPage] = useState(1);

      const [failurePageSize, setFailurePageSize] = useState(10);
      const [failureCurrentPage, setFailureCurrentPage] = useState(1);

    const navigate = useNavigate();
    
    const fetchRecords = async (page,limit,type) => {
        try {  const payload = {
          page,
          limit,
          type,
          id
         };

            const response = await apiService('actual-sales/actualsalesuploadhistorydetails', 'POST', payload);
            if (type === 'successRecords') {
              const recordsWithKeys = response.data.records.map((record, index) => ({
                ...record,
                key: record.id || index, // Add a unique key
              }));
              setSuccessRecords(recordsWithKeys);
              setTotalSuccessRecords(response.data.pagination.total || 0); // Assuming totalCount is provided for success records
            } else {
              const recordsWithKeys = response.data.records.map((record, index) => ({
                ...record,
                key: record.id || index, // Add a unique key
              }));
              setFailedRecords(recordsWithKeys);
              setTotalFailedRecords(response.data.pagination.total || 0); // Assuming totalCount is provided for failed records
            }
        } catch (error) {
            console.error('Error fetching records:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(()=>{
        // fetchRecords(currentPage, pageSize);
        fetchRecords(successCurrentPage, successPageSize, 'successRecords');
    },[successCurrentPage, successPageSize])
    
    useEffect(() => {
      fetchRecords(failureCurrentPage, failurePageSize, 'failureRecords');
    }, [failureCurrentPage, failurePageSize]);
  
    const handleSuccessRecordsPageChange = (page, pageSize) => {
        setSuccessCurrentPage(page);
        setSuccessPageSize(pageSize);
     };
   // Handle pagination change for failed records
    const handleFailureRecordsPageChange = (page, pageSize) => {
        setFailureCurrentPage(page);
        setFailurePageSize(pageSize);
    };
    const {id} = useParams(); // Get the ID from the URL parameters
    
        // Columns for the table
        const dynamicColumns = [
            { title: "Model", dataIndex: "model" },
            { title: "Item Type", dataIndex: "item_type" },
            // { title: "Customer", dataIndex: "customer_name" },
            { title: "Category Code", dataIndex: "category_code" },
            { title: "Part Number", dataIndex: "part_number" },
            { title: "Order Number", dataIndex: "order_number" },
            { title: "Invoice Number", dataIndex: "invoice_number" },
            { title: "Invoice Date", dataIndex: "invoice_date" },
            { title: "Unit Selling Price", dataIndex: "unit_selling_price" },
            { title: "Invoice Amount Wo Gst", dataIndex: "invoice_amount_wo_gst" },
            { title: "Gst Amount", dataIndex: "gst_amount" },
            { title: "Invoice Amount", dataIndex: "invoice_amount" },
            { title: "Invoice Currency Code", dataIndex: "invoice_currency_code" },
            { title: "Cust Po Number", dataIndex: "cust_po_number" },
            
        ];
        const dynamicColumnsTab2 = [
            ...dynamicColumns, // Inherit columns from dynamicColumns
            { title: "Failure Reason", dataIndex: "failure_reason" }, // Add extra column for Tab 2
          ];
    return (
        <div className="bg-white p-4">
           <button className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 cursor-pointer" onClick={() => navigate("/actuals-bulk-upload-history")}>
                  <span className='text-white flex flex-row'>  <FaLongArrowAltLeft /> &nbsp; Back</span>
                </button>
        <Tabs defaultActiveKey="1">
          {/* Tab 1 */}
          <TabPane tab="Success Records" key="1">
            <div className="p-4">
              <Table columns={dynamicColumns} dataSource={successRecords} className="min-w-full text-sm border border-[#D5D5D5]" scroll={{ x: 'max-content' }} 
                   pagination={{
                    current: successCurrentPage,
                    pageSize: successPageSize,
                    total: totalSuccessRecords,
                    onChange: handleSuccessRecordsPageChange,
                  }}
              />
            </div>
          </TabPane>
          
          {/* Tab 2 */}
          <TabPane tab="Failed Records" key="2">
            <div className="p-4">
              <Table columns={dynamicColumnsTab2} dataSource={failedRecords} className="min-w-full text-sm border border-[#D5D5D5]"  scroll={{ x: 'max-content' }} 
                 pagination={{
                  current: failureCurrentPage,
                  pageSize: failurePageSize,
                  total: totalFailedRecords,
                  onChange: handleFailureRecordsPageChange,
                }}
              />
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
};

export default ActualSaleBulkUploadHistoryDetails;      